define([
    "./nlgTruckAllocationModule",
    "./nlgTruckAllocationService",
    "./nlgTruckAllocationDirective",
    "./nlgTruckAllocationProvider"
], function () {
});
